module.exports = __webpack_public_path__ + "static/img/10.9d98213.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/eng/10.png
// module id = Vm0N
// module chunks = 0